export default {
  install(Vue, opts = {}) {
    Vue.prototype.$fullName = (obj, limit = 100, withPhone = false, middleName = false) => {
      let fullName = ''

      if (obj) {
        if (obj.last_name) fullName += `${obj.last_name.trim()} `
        if (obj.first_name) fullName += `${obj.first_name.trim()} `
        if (middleName && obj.middle_name) fullName += `${obj.middle_name.trim()} `
        if (withPhone && obj.phone) fullName += `${obj.phone.substr(-4)}`
      }

      return fullName.length > limit ? `${fullName.substr(0, limit)}...` : fullName.trim()
    }
  },
}
